module.exports = __webpack_public_path__ + "assets/img/a72bc7437f904afe5afdd40e9f0f80c7.svg";